/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const cookingStateEnumSchema = z
	.union([z.literal(0), z.literal(1), z.literal(2), z.literal(3)])
	.describe("* `0` - Создан\n* `1` - Готовится\n* `2` - Приготовлен\n* `3` - Выдан");
